import * as React from 'react'
import { Box, Button, Container, CssBaseline, Divider, ThemeProvider, Typography } from "@mui/material";
import TitleBar from "../TitleBar/TitleBar";
import theme from '../theme';

export function BucketListHome() {
    const [showNSFW, setShowNSFW] = React.useState(false)
    const onClick = () => setShowNSFW(true)
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ flexGrow: 1 }}>
                <TitleBar />
                <Container>

                    <Typography variant="h3">The Bucket List</Typography>
                    <Typography>In 2021, I started writting new year lists of things I wanted to achieve. As I kept this up I decided to make them more fun and, scarily, public</Typography>
                    <Typography>So below is my bucket list! If you want to join me on any of these fun, interesting, mundane, common, crazy ideas then let me know</Typography>
                    <Typography variant="subtitle1">PS: I'll update these as I go as well</Typography>
                    <Typography variant="subtitle1">PPS: More fun at the bottom</Typography>

                    <Divider flexItem />
                    <Typography variant="h4">Health ⛰️</Typography>
                    <ul>
                        <li>
                            <Typography variant="body1"> ✅ Climb the UK Three Peaks: Snowdon, Scarfell Pike and Ben Nevis</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> ✅ Do a 5K</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> ✅ Do a 10K</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> ✅ Do a half marathon</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Do a marathon</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Do a Hyrox event</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Walk across the alps</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Hike in every UK National Park (10/14): ✅Bannau Brycheiniog, Broads, Cairngorms, ✅Dartmoor, ✅Eryri, ✅Exmoor, ✅Lake District, ✅Lock Lomond & The Trossachs, ✅New Forest, North York Moors, ✅Northumberland, ✅Peak District, Pembrokeshire Coast, ✅South Downs, Yorkshire Dales  </Typography>
                        </li>
                    </ul>

                    <Divider flexItem />
                    <Typography variant="h4">Life 😎</Typography>
                    <ul>
                        <li>
                            <Typography variant="body1"> ✅ Finish the PhD</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> ✅ Actually publish that stupid website you keep avoiding (hehe, proof is here)</Typography>
                        </li>
                    </ul>

                    <Divider flexItem />
                    <Typography variant="h4">Travel ✈️</Typography>
                    <ul>
                        <li>
                            <Typography variant="body1"> Visit Japan during the spring blossoms </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> ✅ Visit Petra and Jordan </Typography>
                        </li>
                        <li>
                        <Typography variant="body1"> Visit the Seven Wonders of the world (3/7): Giza Pyramids, ✅ Great Wall of China, ✅ Petra, ✅ Colosseum, Chichén Itzá, Machu Picchu, Taj Mahal, Christ the Redeemer </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Visit every major European Capital (11/31): ✅Amsterdam, ✅Athens, Belgrade, Berlin, ✅Bern, Bratislavia, ✅Brussels, Bucharest, Budapest, ✅Copenhagen, ✅Dublin, Helsinki, Lisbon, Ljubljana, ✅Luxembourg, Madrid, ✅Monaco, Oslo, ✅Paris, Podgorica, Prague, Reykjavik, Riga, ✅Rome, Sarajevo, ✅Stockholm, Tallinn, Vienna, Vilnius, Warsaw and Zagreb </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Visit these world cities: Austin, Barcelona, Venice, Tokyo, Dallas, Washington, New Orleans, ✅Sydney, Sao Paulo</Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Go to Yosemite National Park </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Go to Cape Canaveral </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> 40 Countries By 40 ( 28/40 )</Typography>
                            <ol>
                                <li>Italy (Every year 🤣)</li>
                                <li>Portugal ( ~ 2000 )</li>
                                <li>Turkey ( 2004 Istanbul )</li>
                                <li>Greece ( 2005 Athens )</li>
                                <li>Belgium ( ~2005/6 Ypres, 2022 Ypres, 2025 Brussels )</li>
                                <li>Spain ( ~ 2005/6 Bilbao; 2019 Seville )</li>
                                <li>France (2008 Paris; 2020 Paris; 2023 Paris; 2024 Bordeaux; 2024 Paris; )</li>
                                <li>South Africa ( 2011 Cape Town, Plettenberg Bay; 2020 Cape Town )</li>
                                <li>Bermuda ( 2011 Hamilton )</li>
                                <li>China ( 2012 Beijin, Xi'an, Chengdu, Hong Kong)</li>
                                <li>The Vatican City (2015 Rome)</li>
                                <li>USA (2016 Atlanta; 2016 Los Angeles; 2017 New York; 2018 New York )</li>
                                <li>Canada (2016 Montreal, Halifax, Toronto; 2018 Vancouver)</li>
                                <li>Monaco (2016 Monaco)</li>
                                <li>Germany ( 2017 Nurembourg; 2019 Stuttgart, Munich)</li>
                                <li>Israel ( 2017 Tel-Aviv, Jerusalem )</li>
                                <li>Ireland ( 2018 Dublin; 2019 Dublin; 2024 Cork, Galway; 2025 Dublin)</li>
                                <li>Netherlands ( 2018 Amsterdam, 2019 Amsterdam )</li>
                                <li>Norway ( 2019 Trondheim )</li>
                                <li>Austria ( 2019 Innsbruck )</li>
                                <li>Switzerland ( 2019, 2025 Bern )</li>
                                <li>Namibia ( 2020 Windhoek )</li>
                                <li>Luxembourg ( 2022 Luxembourg )</li>
                                <li>Denmark ( 2025 Copenhagen )</li>
                                <li>Jordan ( 2025 Amman )</li>
                                <li>Sweden ( 2025 Stockholm )</li>
                                <li>Singapore ( 2026 )</li>
                                <li>Australia ( 2026 Sydney, Perth )</li>
                            </ol>
                        </li>
                    </ul>

                    <Divider flexItem />
                    <Typography variant="h4">Experiences 🤩</Typography>
                    <ul>
                        <li>
                            <Typography variant="body1"> Go to Glastonbury Music Festival </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Drive a race car on a race circuit </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Watch the Tennis at Roland Garros </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Watch the Monaco Grand Prix </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Watch the Singapore Grand Prix </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Camp at the 24 hours of Le Mans </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Experience a full solar exclipse </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Watch a rocket launch </Typography>
                        </li>
                        <li>
                            <Typography variant="body1"> Watch the Northern Lights </Typography>
                        </li>
                    </ul>

                    <Divider flexItem />
                    <Typography variant="h4">The NSFW bit 🫥</Typography>
                    <Button variant="contained" onClick={onClick}>Show</Button>
                    {showNSFW ? <Typography variant="body1" > Ha. Gotcha, you curious thing! 😉</Typography> : null}

                </Container>

            </Box>
        </ThemeProvider>
    );
}